import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const EMPTY_VEHICLE = { brand: '', model: '', plate: '', chassis_number: '', registration_number: '', first_registration: '', color: '', type_approval: '', body_type: '', vehicle_genre: '', displacement_cc: 0, power_kw: 0, total_weight_kg: 0, last_inspection: '', fuel_type: '', insurance_company: '', insurance_number: '', seats_total: 0, seats_front: 0, empty_weight_kg: 0, payload_kg: 0, emission_code: '', vehicle_genre_code: '', body_code: '', special_usage: '' };
const NUMERIC = ['displacement_cc', 'power_kw', 'total_weight_kg', 'seats_total', 'empty_weight_kg'];

const FIELDS = [
  ['plate', 'Immatriculation'], ['brand', 'Marque'], ['model', 'Type / modèle'], ['chassis_number', 'N° de châssis / VIN'],
  ['registration_number', 'N° de matricule'], ['first_registration', '1re mise en circulation'], ['color', 'Couleur'],
  ['vehicle_genre', 'Genre'], ['body_type', 'Carrosserie'], ['type_approval', 'Réception par type'],
  ['displacement_cc', 'Cylindrée (cm³)'], ['power_kw', 'Puissance (kW)'], ['total_weight_kg', 'Poids total (kg)'], ['last_inspection', 'Dernière expertise'],
  ['fuel_type', 'Carburant'], ['seats_total', 'Places'], ['empty_weight_kg', 'Poids à vide (kg)'], ['emission_code', 'Code émissions'],
  ['insurance_company', 'Assurance'], ['insurance_number', 'N° d\'assurance'],
];

export const Field = ({ label, value, onChange, uncertain, testid, type = 'text' }) => (
  <div>
    <Label className={`text-xs ${uncertain ? 'text-amber-700' : ''}`}>{label}{uncertain && ' · à vérifier'}</Label>
    <Input type={type} value={value ?? ''} onChange={e => onChange(e.target.value)} data-testid={testid}
      className={`h-9 ${uncertain ? 'border-amber-400 bg-amber-50' : ''}`} />
  </div>
);

export const VehicleFields = ({ value, onChange, uncertain = [], compact = false }) => {
  const list = compact ? FIELDS.slice(0, 4) : FIELDS;
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="vehicle-fields">
      {list.map(([k, l]) => (
        <Field key={k} label={l} value={value[k] || ''} uncertain={uncertain.includes(k)} testid={`vehicle-${k}-input`}
          onChange={(v) => onChange({ ...value, [k]: NUMERIC.includes(k) ? (parseFloat(v) || 0) : v })} />
      ))}
    </div>
  );
};
